module.exports = __webpack_public_path__ + "static/media/Dalia.3abdbbc1.jpg";